'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router';
import store from 'store';
import indexBy from 'lodash.indexby';

import confirm from '@utils/Confirm';
import FavoriteButton from '../../Widgets/FavoriteButton.react';
import PublisherSubmenu from '../../Publisher/Dashboard/PublisherSubmenu.react';
import ImgResized from '../../Widgets/ImgResized.react';

import './PlanCard.scss';
import '../../Search/Results/RecipeCard.scss'
import '../../Search/Results/PlanCard.scss'

import { fetchDocumentsById, updateCachedDocuments } from '../../../utils/Content';
import BoardStore from '../../../stores/BoardStore';
import AuthStore from '../../../stores/AuthStore';
import {
    getResolvedPlanUuid,
    addPlanToFavorites,
    removeFromFavorites,
    saveVirtualPlan
} from '../../../utils/planUtils';

import { getConfig } from '../../../utils/Env';

export default class PlanCard extends Component {
    static propTypes = {
        plan: PropTypes.object,
        mealTypes: PropTypes.array,
        virtual: PropTypes.bool,
        showFavorites: PropTypes.bool,
        hideTitle: PropTypes.bool,
        showAdvancedMode: PropTypes.bool,
        shortMode: PropTypes.bool,
        shouldLoadPlan: PropTypes.bool,
        planToRender: PropTypes.bool,
        patient: PropTypes.object,
    };

    static defaultProps = {
        virtual: false,
        showFavorites: false,
        hideTitle: false,
        showAdvancedMode: false,
        shortMode: false,
        shouldLoadPlan: false,
        planToRender: false,
    };

    static contextTypes = {
        isPublisher: PropTypes.bool,
        showCustomizer: PropTypes.func,
        confirm: PropTypes.func,
        replaceMealPlan: PropTypes.func,
        onBeforeUnfavorite: PropTypes.func,
        onAfterUnfavorite: PropTypes.func,
    };

    constructor(props) {
        super(props);

        this.state = {
            recommendations: [],
            plan: props.plan,
            loaded: false,
        };
    }

    componentDidMount = () => {
        const {shouldLoadPlan} = this.props;
        // Get a list of boards shared with the users dietitians (there may be more than one).
        const boards = BoardStore.getBoards().filter(board => board.dietitian_recommendation);
        let recommendations = [];

        boards.forEach(board => {
            board.contents.forEach(content => {
                recommendations.push({
                    ...content,
                });
            });
        });

        recommendations = recommendations.sort((a, b) => moment(b.created).diff(a.created));

        // Load the plans
        fetchDocumentsById(recommendations.map(r => r.resource_id)).then(documents => {
            documents = indexBy(documents, 'uuid');

            recommendations.forEach(rec => {
                rec.resource = documents[rec.resource_id];
            });

            // Filter out the ones where we couldn't find the resource.
            recommendations = recommendations.filter(r => r.resource);

            this.setState({recommendations});
        });
        shouldLoadPlan && this.loadPlan();
    }

    //Reset state explicitly on prop change
    componentDidUpdate(prevProps) {
        const { planToRender } = this.props;
        //on component did update if current plan has replaced_by in virtual menus reload plan;
        if (prevProps.plan !== this.props.plan) {
            this.setState({plan: this.props.plan});
        }

        if (planToRender) {
            this.checkToUpdateVirtualPlan();
        }
    }

    checkToUpdateVirtualPlan = () => {
        const virtualPlans = store.get('virtual-menus') || {};
        const uuid = this.state.plan?.uuid

        if (virtualPlans[uuid]?.replaced_by) {
            this.loadPlan(virtualPlans[uuid]?.replaced_by)
        }
    }


    loadPlan = (replaceUuid) => {
        let { plan } = this.props;

        let uuid = replaceUuid || plan.uuid;

        if (plan && plan.replaced_by) {
            uuid = plan.replaced_by;
        }

        fetchDocumentsById([uuid]).then(documents => {
            if (!documents[0]) {
                this.setState({loaded: true});
                return;
            }

            // Make a copy so we don't pollute the cached documents pool (just yet anyway).
            plan = JSON.parse(JSON.stringify(documents[0]));
            this.setState({
                plan,
                loaded: true
            });
        });
    }

    renderMealPlanSize = () => {
        const { plan } = this.state;

        const mealTypeCounts = plan.items.reduce((count, item) => {
            count[item.meal] = (count[item.meal] || 0) + 1;
            return count;
        }, {});

        const days = Math.max(...plan.items.map(item => item.offset)) + 1;

        const mealTypes = plan.meal_types || [];
        const dinnerOnlyMealTypes = mealTypes.filter((mealType) => mealType.main_dish === "Dinner").map((mealType) => mealType.name);

        const dinnerOnlyMealPlan = dinnerOnlyMealTypes.length > 0 &&
            Object.keys(mealTypeCounts).every(key => dinnerOnlyMealTypes.includes(key));

        return (
            <section className="plan-size-info" data-dinner={!!dinnerOnlyMealPlan}>
                {days}-{dinnerOnlyMealPlan ? 'dinner plan' : 'day plan'}
            </section>
        );
    }

    onClick = (ev) => {
        const { showCustomizer } = this.context;
        const { onClick } = this.props;
        const { plan } = this.state;

        if (onClick && !(ev.button == 1 || ev.ctrlKey)) {
            onClick(ev);
            ev.preventDefault();
            return;
        }

        if (showCustomizer && !(ev.button == 1 || ev.ctrlKey)) {
            showCustomizer(plan);
            ev.preventDefault();
        }
    }

    link = (element) => {
        const { isPublisher } = this.context;
        const { plan } = this.state;

        if (isPublisher) {
            return <Link to={`/publisher/plan/${plan.uuid}`}>{element}</Link>;
        }

        const newLocation = {
            pathname: `/menus/${plan.uuid}`,
        };

        if (!(plan.links && plan.links.self)) {
            newLocation.query = {virtual: 1};
        }

        return <Link to={newLocation} onClick={this.onClick}>{element}</Link>
    }


    renderSearchResultCard = () => {
        const { children, hideTitle} = this.props;
        const { plan } = this.state;

        if (!plan) {
            return <span />
        }

        return (
            <div className="recipe-card plan-card-search-result">
                {this.link(
                    <ImgResized className="recipe-card-image plan-card-search-result-image" src={plan.image} width={300} height={300} />
                )}

                {this.link(<div className="recipe-card-text plan-card-search-result-text">
                    <div>
                        <span>
                            <h2>Meal Plan</h2>
                            <svg className="hero-tag" width="71" height="39" viewBox="0 0 71 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M60.4624 0.5V39C60.4624 39 70.4624 34.9474 70.4624 31.5702V29.8228V10.5C70.4624 4.97715 65.9852 0.5 60.4624 0.5Z" fill="#A30063"/>
                                <path d="M7.82607 16.7647L1.18925 30.5666C0.870011 31.2305 1.35381 32 2.09047 32L69.5 32C70.0523 32 70.5 31.5577 70.5 31.0054V0.982791C70.5 0.430506 70.0523 0 69.5 0H2.0619C1.33236 0 0.848365 0.755956 1.15369 1.41852L7.83306 15.9128C7.95785 16.1836 7.95529 16.496 7.82607 16.7647Z" fill="#A30063"/>
                            </svg>
                        </span>
                        <h3>{!hideTitle ? plan.title : null}</h3>
                        {children}
                        {this.renderMealPlanSize()}
                    </div>
                </div>)}

                <FavoriteButton onBeforeUnfavorite={this.checkRecommendations} onFavorite={this.onFavorite} plan={plan} />
            </div>
        );
    }

    checkRecommendations = async () => {
        const {recommendations, plan} = this.state;

        const recommendation = recommendations.find((recommendation) => recommendation.resource.uuid == plan.uuid);

        if (recommendation) {
            // Show alert using modern confirm (already returns Promise)
            await confirm(
                `This meal plan cannot be removed from favorites since it was recommended by ${recommendation.author_name}. Please contact ${recommendation.author_name} to request removal.`,
                {
                    acceptText: 'OK',
                    rejectText: null  // Hide cancel button for alert behavior
                }
            );

            return true; // Block removal
        }

        return false; // Allow removal
    }


    onFavorite = async () => {
        const { replaceMealPlan } = this.context;
        const { plan } = this.state;

        // Get resolved UUID for virtual plans that were saved
        const resolvedUuid = getResolvedPlanUuid(plan);
        const planToCheck = { ...plan, uuid: resolvedUuid };

        // Check if plan is already favorited
        const isInBoards = BoardStore.getBoardsByResourceId(resolvedUuid).length > 0;

        if (isInBoards) {
            // Check dietitian recommendations first
            if (await this.checkRecommendations()) {
                return; // Blocked by dietitian recommendation
            }

            // Confirm before removing from favorites (confirm already returns Promise)
            const confirmed = await confirm(
                'Remove this meal plan from your favorites?',
                {
                    acceptText: 'Remove',
                    rejectText: 'Cancel'
                }
            );

            if (!confirmed) {
                return; // User cancelled
            }

            // Unfavorite: remove from boards
            removeFromFavorites(planToCheck);

            // Notify Browser to update UI in Favorites page
            const { onAfterUnfavorite } = this.context;
            if (onAfterUnfavorite) {
                const itemsToRemove = [{
                    resource_id: planToCheck.uuid,
                    resource_type: planToCheck.type || 'plan'
                }];
                onAfterUnfavorite(itemsToRemove);
            }

            return;
        }

        // Favorite: check if plan is virtual first
        if (!(plan.links && plan.links.self)) {
            // Virtual plan - must save to database first before favoriting
            // This is necessary because My Favorites fetches plans by UUID from the API.
            // Virtual plans only exist locally and won't be found by My Favorites.
            this.setState({saving: true});

            try {
                const result = await saveVirtualPlan(plan);

            if (result.success && result.plan) {
                // Update state with saved plan
                this.setState({saving: false, plan: result.plan, dirty: false}, this.syncAssets);

                // Notify parent component of plan change
                if (replaceMealPlan) {
                    replaceMealPlan(plan, result.plan);
                }

                // Add the SAVED plan to favorites (with real DB UUID)
                addPlanToFavorites(result.plan, this.props.patient);
            } else {
                this.setState({saving: false, saveError: result.error});
            }
            } catch (error) {
                this.setState({saving: false, saveError: error.message});
                // Don't try to favorite virtual plans that failed to save
            }
        } else {
            // Already saved plan - just add to favorites
            addPlanToFavorites(plan, this.props.patient);
        }
    }


    savePlan = (plan) => {
        // eslint-disable-next-line no-unused-vars
        const { uuid, links, type, created, ...rest } = plan;

        return AuthStore.fetch(getConfig('recipe_api') + plan.links.self.href, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; schema=plan/1',
                'Accept': 'application/json; schema=plan/1',
            },
            body: JSON.stringify(rest),
        });
    }

    onSavePlan = async () => {
        // Save the plan to the database. If it's already curated, then we just save
        // it. If it's virtual, then we store it and reset our state to the new version.
        const { replaceMealPlan } = this.context;
        const { plan } = this.state;

        // We also need to remove the local edit copy and the virtual copy.
        this.setState({saving: true});

        if (!(plan.links && plan.links.self)) {
            // Virtual plan - use utility function
            const result = await saveVirtualPlan(plan);

            if (result.success && result.plan) {
                // Meal plan is no longer dirty, unset the dirty flag.
                this.setState({saving: false, plan: result.plan, dirty: false}, this.syncAssets);

                // If we have a replaceMealPlan context function, let's inform our ancestor of the change
                replaceMealPlan && replaceMealPlan(plan, result.plan);

                addPlanToFavorites(result.plan, this.props.patient);
            } else {
                this.setState({saving: false, saveError: result.error});
            }

            return;
        }

        // Otherwise, save it to it's self-link.
        this.savePlan(plan).then(
            response => {
                // Courtesy update of plan document in cache
                updateCachedDocuments([response]);

                // We're clean now, so remove our locally edited copy.
                store.remove('menu-edited-' + response.uuid);

                this.setState({lastSaved: moment(), saveError: false, saving: false, dirty: false});
                this.resetLastSaved();
                addPlanToFavorites(response, this.props.patient);
            },
            error => {
                this.setState({lastSaved: null, saveError: error.message, saving: false});
            }
        );

    }


    renderNormalPlanCard = () => {
        const { isPublisher } = this.context;
        let { hideTitle, showFavorites, showAdvancedMode, shortMode, onRemove } = this.props;
        const { plan} = this.state;

        const aspect = !shortMode
                     ? { w: 400, h: 500 }
                     : { w: 600, h: 600 };

        return (
            <div className="plan-card" data-advanced={showAdvancedMode} data-short={shortMode}>
                <div className="plan-card-fan1"></div>
                <div className="plan-card-fan2"></div>
                <div className="plan-card-image-container">
                    {onRemove ?
                        <button className="delete-btn" onClick={onRemove} title="Remove meal plan">
                            <i className="icon-trash-can" />
                        </button>
                    : null}

                    {this.link(<ImgResized className="plan-card-image" src={plan.image} width={aspect.w} height={aspect.h} />)}

                    <div className="plan-card-contents">
                        {this.link(<div className="plan-card-text">
                            <div>
                                {this.renderMealPlanSize()}
                                <h3>{!hideTitle ? plan.title : null}</h3>
                            </div>
                        </div>)}

                        {isPublisher ? <PublisherSubmenu plan={plan} /> : null}
                        {showFavorites && !isPublisher ? <FavoriteButton onBeforeUnfavorite={this.checkRecommendations} onFavorite={this.onFavorite} plan={plan} /> : null}
                    </div>
                </div>
            </div>
        );
    }


    render() {
        const { isSearchResult, shouldLoadPlan } = this.props;
        const { plan, loaded} = this.state;

        if (!plan || (!loaded && shouldLoadPlan)) {
            return <span />
        }

        return (
            <>
                {isSearchResult ? this.renderSearchResultCard() : this.renderNormalPlanCard()}
            </>
        );
    }
}
